<template>
	<!-- 组件主盒子 -->
	<div class="stbox">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>数据分析</el-breadcrumb-item>

			<el-select style="margin-left: 20px;" v-model="getJZ" placeholder="选择部门" @change="handleNodeClick" size="small" v-if="user.username == 'admin'">
				 <el-option
				   v-for="item in deptData"
				   :key="item.id"
				   :label="item.departmentName"
				   :value="item.id">
				 </el-option>
			</el-select>
		</el-breadcrumb>

    <div class="trow">

      <PreModular perms="data:sj">
          <h3 class="tj-t"><i class="el-icon-menu"></i> 数据总览</h3>
          <el-row :gutter="4">
          	<el-col :span="12">
          		<div class="zl-item" style="background: #348cd4;">
          			<span>充值余额合计（元）</span>
          			<p>{{indexData.countMoney}}</p>
          		</div>
          	</el-col>
          	<el-col :span="12">
          		<div class="zl-item" style="background: #2ec7c9;">
          			<span>电表总数量（个）</span>
          			<p>{{indexData.countMeterInfo}}</p>
          		</div>
          	</el-col>
          	<el-col :span="8">
          		<div class="zl-item" style="background: #b6a2de;">
          			<span>开户数量(个)</span>
          			<p>{{indexData.countBdingMeterInfo}}</p>
          		</div>
          	</el-col>
          	<el-col :span="8">
          		<div class="zl-item scale" style="background: #95706d;cursor: pointer;" @click="showDialog('nobind')">
          			<span>未开户数量（个）</span>
          			<p>{{indexData.countNotBdMeterInfo}}</p>
          		</div>
          	</el-col>
          	<el-col :span="8">
          		<div class="zl-item scale" style="background: #d87a80; cursor: pointer;" @click="showDialog('qf')" >
          			<span>欠费数量（个）</span>
          			<p>{{indexData.countQfRunning}}</p>
          		</div>
          	</el-col>
          </el-row>
      </PreModular>


      <PreModular perms="data:tj">
        <el-row type="flex" justify="space-between">
          <el-col>
        	<h3 class="tj-t"><i class="el-icon-pie-chart"></i> 能耗用途统计</h3>
          </el-col>
          <el-col style="line-height: 60px;">
        	<el-radio-group v-model="timeType" @change="FindEnergyYtList">
        	 <el-radio label="day">昨天</el-radio>
        	 <el-radio label="month">当月</el-radio>
        	 <el-radio label="year">当年</el-radio>
        	</el-radio-group>
          </el-col>
        </el-row>
        <div class="paybox" >
          <p style="text-align: center;color: ddd; font-size: 14px;" v-if="noData">暂无数据</p>
          <div class="cavasbox" ref="payEchart"></div>
        </div>
        <div class="ntype">
         <el-radio-group v-model="ntype" size="mini" @change="FindEnergyYtList">
          <el-radio-button :label="15">电</el-radio-button>
          <el-radio-button :label="16">水</el-radio-button>
         </el-radio-group>
        </div>

      </PreModular>

      <PreModular perms="data:rl">
        <el-row type="flex" justify="space-between">
          <el-col>
        	<h3 class="tj-t"><i class="el-icon-date"></i> 能耗日历</h3>
          </el-col>
          <el-col style="line-height: 60px; text-align: right;">
        	<el-radio-group v-model="etype"  @change="getDataByDate" size="mini">
        	  <el-radio-button :label="15">电</el-radio-button>
        	  <el-radio-button :label="16">水</el-radio-button>
        	</el-radio-group>
          </el-col>
        </el-row>
        <el-row :gutter="14">
        	<el-col :span="15">
        		<el-calendar v-model="cdate">
        	  <template slot="dateCell" slot-scope="{date, data}" >
        		 <span @click="getDate(data)">{{ data.day.substring(8)}}</span>
        	  </template>

        	</el-calendar>
        	</el-col>
        	<el-col :span="9">
        		<el-card class="box-card">
        			<div slot="header" class="clearfix">
        				<span>日用量</span>
        			</div>
        			<div>{{dayData}}</div>
        		</el-card>
        		<el-card class="box-card">
        			<div slot="header" class="clearfix">
        				<span>月用量</span>
        			</div>
        			<div>{{monthDate}}</div>
        		</el-card>
        	</el-col>
        </el-row>
      </PreModular>

    </div>

    <div class="trow">
      <PreModular perms="data:fl">
        <el-row type="flex" justify="space-between">
        	<el-col>
        		<h3 class="tj-t"><i class="el-icon-s-data"></i> 能耗分类</h3>
        	</el-col>
        	<el-col style="line-height: 60px;text-align: right;">
        		<el-radio-group v-model="ftimeType" @change='getFenLei'>
        			<!-- <el-radio label="time">逐时</el-radio> -->
        			<el-radio label="day">逐日</el-radio>
        			<el-radio label="month">逐月</el-radio>

        		</el-radio-group>
        	</el-col>
        	<!-- <el-col class="tj-title">
        		月数据：2018-07 至 2019-07
        	</el-col> -->
        </el-row>
        <div class="paybox">
        	<div class="cavasbox" ref="fengLei"></div>
        </div>
      </PreModular>

      <PreModular perms="mod:noData">
        <h3 class="tj-t"><i class="el-icon-date"></i> 未绑定价格表数据（{{unprice.length}}）</h3>
        <!-- <div class="data-list" >
        	<div class="data-item" v-for="item in unprice">{{item}}</div>
        </div> -->
        <el-table size="small" :data="unpriceTables"  v-loading="loading" border element-loading-text="加载中" style="width: 100%;" stripe height="300">
          <el-table-column align="center"  type="index" width="60">
          </el-table-column>
          <el-table-column label="计量点名称" prop="name">
          </el-table-column>
        </el-table>

      </PreModular>

    </div>



    <el-dialog :title="title" :visible.sync="editFormVisible" @click="editFormVisible = false" width="42%">

      <el-table size="small" :data="dialogData"  v-loading="loading" border element-loading-text="加载中" style="width: 100%;" stripe height="300">
        <el-table-column align="center"  type="index" width="60">
        </el-table-column>
        <el-table-column label="计量点名称" prop="name">
        </el-table-column>
      </el-table>
    </el-dialog>

	</div>
</template>
<script>
import Chart from 'echarts'
import 'echarts/theme/macarons.js'
import { findconutMeterInfo,findEnergyDay,findEnergyYtList,findEnergyBranchList} from '../../api/dataMG.js'
import { getDepartmentTerminalInfoLis} from '../../api/energyMG'
import { timestampToTime } from '../../utils/util'
import PreModular from "@/views/permission/preModular";
import store from '@/vuex/store'
export default {
	name: "welcome",
	data() {
		return {
			radio: 1,
			machineNo: '',
      loading:false,
			type: 'day',
      title:'',
      date:"",
      editFormVisible:false,
      dialogData:[],
      unpriceTables:[],
      cdate:new Date()-24 * 60 * 60 * 1000,
      dataDate:'',
			indexData:{},
			unuser:[],
			unprice:[],
			unpower:[],
			unwater:[],
      etype:15,
      ntype:15,
       noData:false,
      deptData:[],
			user:{},
      getJZ:"",
      dayData:"",
      monthDate:"",
      departmentId:"",
      timeType:"month",
      ftimeType:"month",
      methodsList:[]
		}
	},
	// 导入组件
	components: {
    PreModular
	},

	created() {



		this.user = JSON.parse(sessionStorage.getItem('userdata'))
    this.date = timestampToTime(new Date() -  24 * 60 * 60 * 1000).substring(0,10)
    if(this.user.username == 'admin'){
      this.getJZ = this.user.departmentName
      this.getJzData().then(res => {
        this.departmentId = res[0].id
        //this.getDataByDate()
      });
    }else{
      //this.getDataByDate()
    }
    this.getData()
	},
	// 挂载结束状态(里面是操作)
	mounted() {


		//this.FindEnergyYtList()
		//this.getFenLei();
    //请求vuex获取菜单数据，leftnav已经请求过一次，不可取，以后有好的方法再改善
    this.$store.dispatch('getMenuList').then(res => {

     this.getPermission(res)
     let methods = this.$options.methods
     console.log(this.methodsList)
     this.methodsList.forEach(item =>{

        methods[item].call(this)
     })
    })

    this.$nextTick(() => {

        // setTimeout(()=>{
        //   // 点击前一个月
        //   let prevBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(1)');
        //   let minBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(2)');
        //   let nextBtn = document.querySelector('.el-calendar__button-group .el-button-group>button:nth-child(3)');

        //   console.log(prevBtn)
        //   prevBtn.addEventListener('click',() => {
        //     this.date = timestampToTime(this.cdate).substring(0,10)
        //     this.getDataByDate()
        //   })
        //   minBtn.addEventListener('click',() => {
        //     this.date = timestampToTime(this.cdate).substring(0,10)
        //     this.getDataByDate()
        //   })

        //   nextBtn.addEventListener('click',() => {
        //     this.date = timestampToTime(this.cdate).substring(0,10)
        //     this.getDataByDate()
        //   })
        // },1000)

      })
	},
	// 里面的函数只有调用才会执行
	methods: {

    //获取首页要请求的接口
    getPermission(list) {
    	list.forEach(menu => {

    		if(menu.interfaceName != "" && menu.interfaceName != undefined){
    			this.methodsList.push(menu.interfaceName)
    		}

    		if(menu.menus.length != 0){
    			this.getPermission(menu.menus)

    		}
    	})
    },




    //能耗用途统计
		FindEnergyYtList() {

      let param = {
        timeType:this.timeType,
        energyType:this.ntype,
        departmentId:this.departmentId
      }

     findEnergyYtList( param).then(res => {
       if( res.status == 1 ){
         let lenData = []
         this.noData = res.data.length == 0 ? true:false
         res.data.forEach(item => {
           lenData.push(item.name)
         })


         let option = {
           tooltip: {
             trigger: 'item',
             formatter: "{a} <br/>{b} : {c} ({d}%)"
           },
           legend: {
             orient: 'vertical',
             x: 'left',
             data: lenData
           },
           toolbox: {
             show: true,
             feature: {
               mark: {
                 show: true
               },
               magicType: {
                 show: true,
                 type: ['pie', 'funnel'],
                 option: {
                   funnel: {
                     x: '25%',
                     width: '50%',
                     funnelAlign: 'left',
                     max: 1548
                   }
                 }
               },
             }
           },
           calculable: true,
           series:
             [{
               name: '能耗用途统计',
               type: 'pie',
               radius: '55%',
               center: ['50%', '60%'],
               data: res.data,
               label: {
                 normal: {
                   show: true,
                   formatter: "{b}\n({d}%)"
                 }
               }
             }]
         }
         this.chart = Chart.init(this.$refs.payEchart, 'macarons')
         this.chart.setOption(option)
       }


     })
		},


    //能耗分类统计
    getFenLei() {
      //findEnergyBranchList

      let dateStr = ''
      if( this.ftimeType == 'month' ){
         dateStr = timestampToTime(new Date()).substring(0,4)
      }else if( this.ftimeType == 'day'){
         dateStr = timestampToTime(new Date()).substring(0,7)
      }else {
        dateStr = timestampToTime(new Date()).substring(0,10)
      }


      let param = {
        timeType:this.ftimeType,
        date:dateStr,
        departmentId:this.departmentId
      }

      findEnergyBranchList(param).then(res => {
        if(res.status == 1){
          let option = {
          	tooltip: {
          		trigger: 'axis'
          	},
          	legend: {
          		data: ['电力（千瓦时）', '水（立方米）'],
          	},
          	toolbox: {
          		show: true,
          		feature: {
          			mark: {
          				show: true
          			},
          			dataView: {
          				show: true,
          				readOnly: false
          			},
          			magicType: {
          				show: true,
          				type: ['line', 'bar']
          			},
          			restore: {
          				show: true
          			},
          			saveAsImage: {
          				show: true
          			}
          		}
          	},
          	calculable: true,
          	xAxis: [{
          		type: 'category',
          		data: res.data.dayList
          	}],
          	yAxis: [{
          		type: 'value',

          	}],
          	series: [
              {
          			name: '电力（千瓦时）',
          			type: 'bar',
          			data: res.data.data.powerDataList,
          			markPoint: {
          				data: [{
          						type: 'max',
          						name: '最大值'
          					},
          					{
          						type: 'min',
          						name: '最小值'
          					}
          				],

          			},
          			markLine: {
          				data: [{
          					type: 'average',
          					name: '平均值'
          				}]
          			}
          		},
          		{
          			name: '水（立方米）',
          			type: 'bar',
          			data: res.data.waterDataList,
          			markPoint: {
          				data: [{
          						type: 'max',
          						name: '最大值'
          					},
          					{
          						type: 'min',
          						name: '最小值'
          					}
          				]
          			},
          			markLine: {
          				data: [{
          					type: 'average',
          					name: '平均值'
          				}]
          			}
          		}
          	]
          }
          this.chart = Chart.init(this.$refs.fengLei, 'macarons')
          this.chart.setOption(option)

        }
      })
		},

    //能耗日历
    getDataByDate(){
      let param = {
        date:this.date,
        energyType:this.etype,
        departmentId:this.departmentId
      }
      findEnergyDay(param).then(res => {
        if(res.status == 1){
          this.dayData = res.data.dayData
          this.monthDate = res.data.monthDate
        }
      })
    },

    handleNodeClick(e){
      this.departmentId = e
      //this.getDataByDate()
      this.FindEnergyYtList()
      //this.getFenLei()
    },

    showDialog(type){
      this.editFormVisible = true
      if(type == 'nobind'){
        this.title = '未开户数据'

        this.dialogData = []
        this.unuser.forEach(item => {
          this.dialogData.push({
            name:item
          })
        })

      }else if( type == 'qf'){
        this.title = '欠费数据'
        this.dialogData = []
        this.indexData.qfRunningList.forEach(item => {
          this.dialogData.push({
            name:item
          })
        })
      }
    },

    getJzData:function(){
    	return new Promise((resolve,reject) => {
    		getDepartmentTerminalInfoLis().then(res => {
    			this.treeLoad = false
    			if(res.status == 1){
    				let arr = []
    				this.deptData = res.data.menuDepList

    				resolve(res.data.menuDepList)
    			}
    			else{
    				this.$message.error(res.msg)
    			}
    		})
    	})

    },


    getDate(val){
      this.date = val.day
      this.getDataByDate()
    },
		getData(){
      this.loading  = true
			findconutMeterInfo().then(res =>{
        this.loading = false
				if( res.status == 1){
					this.indexData = res.data
					this.unuser = res.data.list.unuser
					this.unprice =  res.data.list.unprice
					this.unpower = res.data.unUpdateObj.power
					this.unwater = res.data.unUpdateObj.water



          this.unprice.forEach(item => {
            this.unpriceTables.push({
              name:item
            })
          })

				}

			}).catch(err =>{
        this.loading = false
				 this.$message.error('获取数据失败，请稍后再试！')
			})
		}




  }
};
</script>
<style>

  .trow{
    display: flex;
  }
  .trow .tcol{
    flex: 1;
    height: 380px;
  }
	.sbox1 .data-list{
		overflow-y:auto;
		font-size: 14px;
		line-height: 30px;
		height: 300px;
	}
	.tbox .data-list{
		overflow-y:auto;
		font-size: 14px;
		line-height: 30px;
		height: 300px;

	}

	.el-calendar-table .el-calendar-day {
		height: 30px;
	}

	.el-backtop,
	.el-calendar-table td.is-today {
		background: #ccc;
		color: #FFFFFF;
	}
 .el-calendar-table td.is-selected {
  	background: #409EFF;
    color: #FFFFFF;
  }
  .re{
    position: relative;
  }
  .el-calendar-table td .el-calendar-day:hover {
   	background: #409EFF !important;
    	color: #FFFFFF;

   }
	.tj-t{
		color: #5ab1ef;
		font-weight: bold;
	}

	.tj-title {
		line-height: 60px;
		color: #666;
		font-size: 14px;
		text-align: right;
	}

	.tbox {
		border: 2px solid #f4f4f4;
		border-left: 0;
		height: 380px;
		overflow: hidden;
	}

	.sbox1 {
		border-right: 2px solid #f4f4f4;
		border-bottom: 2px solid #f4f4f4;
		height: 380px;
		overflow-y: auto;
	}

  .el-calendar-day{
    position: relative;
  }
  .el-calendar-day span{
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    text-align: center;
    padding-top: 6px;
  }


	.box-card {
		margin-bottom: 14px;
	}
  .ntype{
    position: absolute;
    bottom: 20px;
    left: 20px;
  }

	.el-calendar__body {
		padding: 12px 10px
	}
  .el-calendar__header{
    padding: 10px;
  }
	.stbox {
		
	min-height: 100%;
		box-sizing: border-box;
	}

	.stbgc {
		background-color: #fff;
		height: 60px;
		line-height: 60px;
		border-radius: 5px;
		padding: 0px 16px;
	}

	.stsearch {
		text-align: center;
	}

	.text-c {
		text-align: center;
	}

	.st-gbox {
		background-color: #fff;
		margin-top: 20px;
		border-radius: 5px;
		height: 30vh;
		box-sizing: border-box;
		padding: 10px;
	}

	.cavasbox {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
	}

	.paybox {
		width: 100%;
		background-color: #fff;
		box-sizing: border-box;
		border-radius: 5px;

		height: 32vh;
	}

	.el-calendar__title {
		font-size: 14px;
	}

	.el-calendar-table {
		font-size: 14px;
	}

	.el-card__header {
		padding: 14px 20px;

	}

/* 	.zl-item {
		color: #fff;
		padding: 20px;
		height: 112px;
		margin-bottom: 4px;
	}

	.zl-item span {
		font-size: 14px;
	}

	.zl-item p {
		font-size: 28px;

	} */

	.el-card__body {
		padding: 14px 20px;
		/* color: #F56C6C; */

	}
	.utitle{
		font-weight: bold;
	}
	.udata-list{
		margin-bottom: 10px;
		line-height: 30px;
		font-size: 14px;
	}

  @media screen and (max-width: 1800px) {
    .el-calendar__title{
      display: none;
    }
    .el-calendar__header{
      padding: 10px 0;
    }
    .el-radio{
      margin-right: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/charts/homeTest.vue